import React from "react";
import { connect } from "react-redux";
import store from "@/redux/store";

import { v4 as uuid } from "uuid";

import * as ModalConst from "actions/modalPopupConst";
import AddTreeMap from "views/modals/AddTreeMap";
import OnDelete from "views/modals/OnDelete";

import ModalRemoveItem from "views/modals/confirm/RemoveItem";
import Store from "views/modals/confirm/Store";
import AddInvoiceRow from "views/modals/invoice/AddInvoiceRow";
import StorageBaseMapSelect from "views/modals/settings/StorageBaseMapSelect";

import * as CONST from "@/actions/globalConst";
import { showConfirmModal, hideModal, nextActionEvent} from '@/reducers/ModalPopup'
import {MODAL_POPUP_TYPES} from "@/actions/globalConst";
import AddDocument from "@/views/modals/document/AddDocument";
import Search from "@/views/modals/workprocess/Search";
import Video from "@/views/modals/video/Video";
import DossierDetail from "@/views/modals/dossier/Detail";
import Worklog from "@/views/modals/dossier/Worklog";
import CloseTask from "@/views/modals/dossier/CloseTask";
import AddCalenderItem from "@/views/Agenda/AddCalenderItem";
import { useTranslation, withTranslation, Trans } from "react-i18next";

class ModalPopupController extends React.Component {
  constructor(props) {
    super(props);

    this.state = { modalShow: false };
  }
    
    closeModal=() => {
        store.dispatch( hideModal() );
    }
    nextActionEvent=(nextAction) => {
        store.dispatch( nextActionEvent(nextAction) );
        store.dispatch( hideModal() );
    }
    
    getView=() => {
        const { modalProps } = this.props;
        if(modalProps && modalProps.show === true) {
        switch(modalProps.modal) {
            case MODAL_POPUP_TYPES.STORE_CONFIRM:
                return (<Store modalOptions={modalProps.options}/>);
            case ModalConst.ON_DELETE:
                return (<OnDelete modalPopup={modalPopup} />);
            case ModalConst.ADD_TREE_MAP:
                return (<AddTreeMap modalPopup={modalPopup} />);
            case MODAL_POPUP_TYPES.REMOVE_CONFIRM:
                return (<ModalRemoveItem  modalOptions={modalProps.options}/>);
            case MODAL_POPUP_TYPES.ADD_INVOICE_ROW:
                return (<AddInvoiceRow  modalOptions={modalProps.options}/>);
            case MODAL_POPUP_TYPES.SETTINGS_SET_STORAGE_BASEMAP:
                return (<StorageBaseMapSelect  modalOptions={modalProps.options} closeModal={this.closeModal}/>);
            case MODAL_POPUP_TYPES.ADD_DOCUMENT:
                return (<AddDocument  modalOptions={modalProps.options}/>);
            case MODAL_POPUP_TYPES.ADD_CALENDER_ITEM:
                return (<AddCalenderItem {...this.props}  modalOptions={modalProps.options} item={((modalProps.options?.data) ? modalProps.options.data : this.props?.item)}/>);
            case MODAL_POPUP_TYPES.SHOW_VIDEO: 
                return (<Video/>);
            case MODAL_POPUP_TYPES.ADD_WORKLOG:
                return (<Worklog {...this.props} closeModal={this.closeModal} nextActionEvent={this.nextActionEvent}/>);
            case MODAL_POPUP_TYPES.CLOSE_TASK:
                return (<CloseTask {...this.props} closeModal={this.closeModal} nextActionEvent={this.nextActionEvent}/>);
                
            case MODAL_POPUP_TYPES.DETAIL_DOSSIER:
                return (<DossierDetail {...this.props} closeModal={this.closeModal} nextActionEvent={this.nextActionEvent}/>);
            case MODAL_POPUP_TYPES.SEARCH_WORKPROCESS:
                const { workprocesses, wp_sectors, wp_departments } = this.props;
                return (<Search  modalOptions={modalProps.options} closeModal={this.closeModal} items={workprocesses} wp_sectors={wp_sectors} wp_departments={wp_departments}/>);
        }   
        }
        return (<></>);
    }
    
  render() {
    const { modalPopup } = this.props;
    return (
      <>
       {this.getView()}
      </>
    );
  }

}

function mapStateToProps(state) {
  //const { isLoggedIn, user } = state.auth;
  const { ModalPopupReducer } = state;
      

  let returnObj = {
      modalProps: ModalPopupReducer,
  }
  if(ModalPopupReducer.modal == MODAL_POPUP_TYPES.SEARCH_WORKPROCESS) {
      const { DossierReducer } = state;
      const {workprocesses, wp_sectors, wp_departments} = DossierReducer;
      returnObj.wp_sectors = wp_sectors;
      returnObj.wp_departments = wp_departments;
      returnObj.workprocesses = workprocesses;
  }
  if(ModalPopupReducer.modal == MODAL_POPUP_TYPES.ADD_CALENDER_ITEM) {
      const { CommunicationCycleReducer } = state;
      const {item} = CommunicationCycleReducer;
      returnObj.item = item;
  }
  return returnObj;
}

const ModalPopupControllerInit = (props) => {

    return (<ModalPopupController {...props} />);
}

export default connect(mapStateToProps)(ModalPopupControllerInit);
